import {commitMutation, graphql} from 'react-relay';
import Util from '../forecast-app/shared/util/util';
import * as tracking from '../tracking';

const mutation = graphql`
	mutation createPhaseMutation($input: CreatePhaseInput!) {
		createPhase(input: $input) {
			phase {
				node {
					id
					name
					startYear
					startMonth
					startDay
					deadlineDay
					deadlineMonth
					deadlineYear
					phasePersons(first: 10000) {
						edges {
							node {
								id
								availableMinutes
								scheduledMinutes
								person {
									id
								}
							}
						}
					}
					baselineTargetPrice
					baselineTargetMinutes
					phaseBaselineRoles {
						edges {
							node {
								role {
									id
								}
								baselineMinutes
								baselinePrice
							}
						}
					}
				}
			}
		}
	}
`;

function getConfigs(input) {
	return [
		{
			type: 'RANGE_ADD',
			parentID: input.projectId,
			connectionInfo: [
				{
					key: 'Project_phases',
					rangeBehavior: 'append',
				},
			],
			edgeName: 'phase',
		},
	];
}

function commit(environment, input, onSuccess, onError) {
	tracking.trackEvent('Milestone Created');
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};

	return commitMutation(environment, {
		mutation,
		variables,
		configs: getConfigs(input),
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
